/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationScheduleRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationScheduleRequest>): ScheduleRecommendationScheduleRequest {
        let obj = Object.assign(new ScheduleRecommendationScheduleRequest(), model);
        ScheduleRecommendationScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationScheduleRequest>): ScheduleRecommendationScheduleRequest {
        if (!model) return null;
        return ScheduleRecommendationScheduleRequest.newInstance(<ScheduleRecommendationScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationScheduleRequest) {
        if (!obj) return;

        models.ScheduleRecommendationScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationScheduleRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page_number === undefined) {
            this.page_number = 0;
        }
        if (this.page_size === undefined) {
            this.page_size = 0;
        }
        if (this.filters) {
            models.ScheduleRecommendationScheduleRequestFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Tenant Ids
     */
    tenant_ids: Array<string>;

    /**
     * Currencies
     */
    currencies: Array<models.Currency>;

    /**
     * Service Names
     */
    services: Array<models.CloudServiceName>;

    /**
     * Page Number
     */
    page_number: number;

    /**
     * Number of records per page
     */
    page_size: number;

    /**
     * List Schedule Filters
     */
    filters: models.ScheduleRecommendationScheduleRequestFilter;

    /**
     * Search String for filter Service Accounts
     */
    search: string;

}
